module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medication-information"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.monograph.data.Ndc),
      expression: "!monograph.data.Ndc"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.loadingText))])]), _vm._v(" "), (_vm.monograph.data.Ndc) ? _c('div', {
    staticClass: "monograph"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.monograph.data.Ln))]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered",
    attrs: {
      "id": "image_wrapper"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.monograph.data.ImageUrl,
      "alt": _vm.noImageText
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h6', {
    attrs: {
      "id": "label_warning"
    }
  }, [_vm._v(_vm._s(_vm.labelWarningText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.LabelWarning || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "disclaimer"
    }
  }, [_vm._v(_vm._s(_vm.importantText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.Disclaimer || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "common_brand_names"
    }
  }, [_vm._v(_vm._s(_vm.commonBrandNamesText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.CommonBrands || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "uses"
    }
  }, [_vm._v(_vm._s(_vm.usesText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.Uses || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "side_effects"
    }
  }, [_vm._v(_vm._s(_vm.sideEffectsText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.SideEffects || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "precautions"
    }
  }, [_vm._v(_vm._s(_vm.precautionsText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.Precautions || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "drug_interactions"
    }
  }, [_vm._v(_vm._s(_vm.drugInteractionsText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.DrugInteraction || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "food_interactions"
    }
  }, [_vm._v(_vm._s(_vm.foodInteractionsText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.FoodInteraction || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "overdose"
    }
  }, [_vm._v(_vm._s(_vm.overdoseText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.Overdose || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "missed_dose"
    }
  }, [_vm._v(_vm._s(_vm.missedDoseText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.MissedDose || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "storage"
    }
  }, [_vm._v(_vm._s(_vm.storageText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.Storage || _vm.emptyText))]), _vm._v(" "), _c('h6', {
    attrs: {
      "id": "notes"
    }
  }, [_vm._v(_vm._s(_vm.notesText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.monograph.data.Notes || _vm.emptyText))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205804ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MedicationInformation.vue
// module id = 227
// module chunks = 4 5 7 8 9 10 12 16